



















import { Component, Vue } from 'vue-property-decorator';
import RegistrationHeader from '@/components/registration/RegistrationHeader.vue';
import RegistrationPanel from '@/components/registration/RegistrationPanel.vue';
import RegistrationFooter from '@/components/registration/RegistrationFooter.vue';
import { RegistrationSetup } from '@/interfaces/registration/RegistrationSetup';
import { namespace } from 'vuex-class';
const utils = namespace('utils');
const registration = namespace('registration');

@Component({
  components: {
    RegistrationHeader,
    RegistrationPanel,
    RegistrationFooter
  }
})
export default class RegistrationApp extends Vue {
  mounted () {
    const setup: RegistrationSetup = window.registrationSetup;

    this.saveRegistrationSetup(setup);
    this.loadRegistrationData()
      .then(() => this.loadUtilities())
      .then(() => { this.loadingApp = false; })
      .catch(() => { this.errorLoadingApp = true; });
  }

  private loadingApp = true;
  private errorLoadingApp = false;

  @utils.Action
  public loadUtilities!: () => Promise<boolean>;

  @registration.Action
  public saveRegistrationSetup!: (data: RegistrationSetup) => void;

  @registration.Action
  public loadRegistrationData!: () => Promise<boolean>;
}
